module.exports = __webpack_public_path__ + "img/hypatialogo.e097516b.png";